import React, { useState } from 'react';
import {
    Box, Typography, Menu, MenuItem, ListItemIcon,
    Dialog, DialogTitle, DialogContent
} from '@mui/material';
import {
    Logout as LogoutIcon,
    LockReset as PasswordIcon,
    History as AuditIcon,
} from '@mui/icons-material';
import TenantSwitcher from './TenantSwitcher';
import { useAuth } from '../Auth';
// import { useSnackbar } from '../context/SnackbarContext';
import { useNavigate } from 'react-router-dom';
import PasswordChangeForm from './PasswordChangeForm';

export default function Header() {
    const { user, logout } = useAuth();
    // const showSnackbar = useSnackbar();

    // Menu State
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    // Password Dialog State
    const [pwdOpen, setPwdOpen] = useState(false);
    // const [newPassword, setNewPassword] = useState('');

    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);
    const navigate = useNavigate();

    const handleOpenPwd = () => {
        handleMenuClose();
        setPwdOpen(true);
    };

    // const handlePasswordUpdate = async () => {
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_API_URL}/api/staff/${user.id}`, {
    //             method: 'PUT',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${localStorage.getItem('token')}`
    //             },
    //             // Include existing user data + the new password
    //             body: JSON.stringify({
    //                 username: user.username,
    //                 email: user.email,
    //                 role: user.role,
    //                 password: newPassword
    //             })
    //         });

    //         if (response.ok) {
    //             showSnackbar('Password updated successfully');
    //             setPwdOpen(false);
    //             setNewPassword('');
    //         } else {
    //             const errorData = await response.json();
    //             showSnackbar(`Error: ${errorData.message}`, "error");
    //         }
    //     } catch (err) {
    //         console.error("Failed to update password", err);
    //     }
    // };

    return (
        // Use the className="header" from your App.css
        <header className="header">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {/* Logo and Tagline Group */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5, // Controls distance between Logo and Tagline
                        cursor: 'default',
                        ml: -1
                    }}
                    onClick={() => window.location.href = '/'}
                >
                    <Box
                        component="img"
                        src="/Verisafe logo light.png"
                        alt="VeriSafe Logo"
                        sx={{
                            height: 60, // Much better scale for a header
                            width: 'auto',
                            display: 'block'
                        }}
                    />

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'white',
                            opacity: 0.8,
                            fontStyle: 'italic',
                            fontWeight: 300,
                            fontSize: '0.875rem',
                            letterSpacing: '0.5px',
                            mb: -2.8, // Tiny nudge to align with logo text baseline
                            ml: -1,
                            whiteSpace: 'nowrap'
                        }}
                    >
                        Secure · Verify · Trust
                    </Typography>
                </Box>
            </Box>


            {/* Right Side Grouping */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>

                {/* 1. The Switcher */}
                <TenantSwitcher />

                {/* Clickable User Section */}
                <Box
                    onClick={handleMenuClick}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.8 }
                    }}
                >
                    <Typography
                        component="h1"
                        sx={{ fontWeight: 700, color: 'white', fontSize: '1.0rem', textTransform: 'capitalize' }}
                    >
                        {user?.username}
                    </Typography>
                    <Typography sx={{ color: 'white', fontSize: '0.8rem', opacity: 0.8 }}>
                        Account Options ▾
                    </Typography>
                </Box>

                {/* The Dropdown Menu */}
                <Menu
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    slotProps={{
                        paper: {
                            sx: {
                                mt: 1, // Shifts the menu DOWN (12px)
                                ml: 2,   // Shifts the menu RIGHT (16px)
                                // If the right shift isn't working as expected due to the 'right' anchor:
                                transform: 'translateX(10px)', // Precise alternative for shifting right
                                elevation: 3,
                                minWidth: 180,
                            }
                        }
                    }}
                >
                    <MenuItem onClick={handleOpenPwd}>
                        <ListItemIcon><PasswordIcon fontSize="small" /></ListItemIcon>
                        Change Password
                    </MenuItem>

                    {user?.role === 'superuser' && (
                        <MenuItem onClick={() => { handleMenuClose(); navigate('/admin/audit-log'); }}>
                            <ListItemIcon><AuditIcon fontSize="small" /></ListItemIcon>
                            System Audit Log
                        </MenuItem>
                    )}

                    <MenuItem onClick={logout}>
                        <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                        Logout
                    </MenuItem>
                </Menu>
            </Box>

            {/* Password Reset Dialog */}
            <Dialog open={pwdOpen} onClose={() => setPwdOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>Update Password</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2, mt: 1 }}>
                        Enter a new password for <strong>{user?.username}</strong>
                    </Typography>

                    <PasswordChangeForm
                        onSuccess={() => setPwdOpen(false)}
                        onCancel={() => setPwdOpen(false)}
                    />
                </DialogContent>
            </Dialog>
        </header>
    );
}